// Ráhelyezi a fókuszt az elemre; natív autofocus nem működik SPA-navigációnál.
export default {
  mounted(el: HTMLElement) {
    el.focus()
  },
  unmounted(el: HTMLElement) {
    el.blur()
  }
}
